/* Click & Collect : choix du mode dans le panier + acceptation obligatoire des conditions.
   Fichier autonome, sans dépendance. Un seul état pour toute la page (tiroir + page panier).
   Préférence de livraison transmise au checkout par l'API Storefront (sans jeton) : « Retrait » ou « Expédier ». */
(() => {
  if (customElements.get('click-collect')) return;

  const KEY = 'Click & Collect';
  const STORE = 'cc-mode';
  const CHECKOUT = '[name="checkout"], a[href$="/checkout"], a[href*="/checkout?"]';
  const EXPRESS = '.cart-summary__express, .additional-checkout-buttons, shopify-accelerated-checkout-cart, [data-shopify="dynamic-checkout-cart"]';
  const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const state = { ready: false, mode: 'ship', accepted: false };

  const blocked = () => state.mode === 'collect' && !state.accepted;
  const elements = () => [...document.querySelectorAll('click-collect')];
  const remember = () => { try { sessionStorage.setItem(STORE, state.mode); } catch (e) {} };
  const recall = () => { try { return sessionStorage.getItem(STORE); } catch (e) { return null; } };
  const wait = (ms) => new Promise((r) => setTimeout(r, ms));

  // Préférence transmise au checkout : Click & Collect → onglet « Retrait », sinon « Expédier »
  let synced = null;
  async function deliveryPref(mode) {
    const cart = await fetch(`${ROOT}cart.js`).then((r) => r.json());
    if (!cart.token) return;
    await fetch('/api/2026-10/graphql.json', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        query: 'mutation($id: ID!, $b: CartBuyerIdentityInput!) { cartBuyerIdentityUpdate(cartId: $id, buyerIdentity: $b) { userErrors { message } } }',
        variables: { id: `gid://shopify/Cart/${cart.token}`, b: { preferences: { delivery: { deliveryMethod: [mode === 'collect' ? 'PICK_UP' : 'SHIPPING'] } } } },
      }),
    });
    synced = mode;
  }
  function changed(label) {
    synced = null;
    save(label);
    deliveryPref(state.mode).catch(() => {});
    refresh();
  }

  function refresh() {
    // Un bloc pas encore initialisé (plusieurs blocs sur la page) n'a pas encore render : il se mettra à jour à son tour
    elements().forEach((el) => { if (typeof el.render === 'function') el.render(); });
    const b = blocked();
    document.querySelectorAll(CHECKOUT).forEach((btn) => btn.toggleAttribute('aria-disabled', b));
    document.querySelectorAll(EXPRESS).forEach((x) => { x.hidden = b; });
  }

  // Enregistre (ou efface) l'attribut de panier, repris sur la commande
  function save(label) {
    const stamp = new Date().toLocaleString('fr-FR', { dateStyle: 'short', timeStyle: 'short' });
    const value = state.mode === 'collect' && state.accepted ? `${label || 'Conditions acceptées le'} ${stamp}` : '';
    return fetch(`${ROOT}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { [KEY]: value } }),
    }).catch(() => {});
  }

  function stop(e) {
    if (!blocked()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    const list = elements();
    const el = list.find((x) => x.offsetParent !== null) || list[0];
    if (el) el.showError();
  }

  // Avant de partir au paiement : transmet le mode choisi (2,5 s max, puis on part quoi qu'il arrive)
  function syncThen(e, go) {
    if (!elements().length || synced === state.mode) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    const mode = state.mode;
    Promise.race([deliveryPref(mode), wait(2500)]).catch(() => {}).finally(() => { synced = mode; go(); });
  }

  // Écoute en phase de capture : passe avant les scripts du thème
  document.addEventListener('click', (e) => {
    const target = e.target.closest && e.target.closest(CHECKOUT);
    if (!target) return;
    if (blocked()) return stop(e);
    syncThen(e, () => target.click());
  }, true);
  document.addEventListener('submit', (e) => {
    const sub = e.submitter;
    if (!sub || !sub.matches(CHECKOUT)) return;
    if (blocked()) return stop(e);
    syncThen(e, () => e.target.requestSubmit(sub));
  }, true);

  class ClickCollect extends HTMLElement {
    connectedCallback() {
      this.radios = [...this.querySelectorAll('input[type="radio"]')];
      this.accept = this.querySelector('[data-cc-accept]');
      this.panel = this.querySelector('[data-cc-panel]');
      this.error = this.querySelector('[data-cc-error]');

      // Premier bloc de la page : l'état vient du panier (attribut), sinon du choix fait pendant la session.
      // Blocs recréés ensuite (le tiroir est re-rendu après un changement de quantité) : ils reprennent l'état courant.
      if (!state.ready) {
        state.ready = true;
        if (this.dataset.accepted === 'true') { state.mode = 'collect'; state.accepted = true; }
        else if (recall() === 'collect') { state.mode = 'collect'; state.accepted = false; }
      }

      this.radios.forEach((r) => r.addEventListener('change', () => {
        if (!r.checked) return;
        state.mode = r.value;
        if (state.mode !== 'collect') state.accepted = false;
        remember();
        changed(this.dataset.label);
      }));
      this.accept.addEventListener('change', () => {
        state.accepted = this.accept.checked;
        changed(this.dataset.label);
      });
      refresh();
    }

    render() {
      if (!this.radios) return;
      this.radios.forEach((r) => { r.checked = r.value === state.mode; });
      this.accept.checked = state.accepted;
      this.panel.hidden = state.mode !== 'collect';
      if (!blocked()) {
        this.error.hidden = true;
        this.classList.remove('is-error');
      }
    }

    showError() {
      this.panel.hidden = false;
      this.error.hidden = false;
      this.classList.add('is-error');
      this.scrollIntoView({ block: 'center', behavior: 'smooth' });
      this.accept.focus({ preventScroll: true });
    }
  }

  customElements.define('click-collect', ClickCollect);
})();
